interface ChipSVGProps {
  color: string;
  style: React.CSSProperties;
}

const ChipSVG = ({ color, style }: ChipSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="53"
    height="52"
    viewBox="0 0 53 52"
    fill="none"
  >
    <g clipPath="url(#clip0_955_7771)">
      <path
        d="M32.6083 32.3283H19.9517V19.6716H32.6083V32.3283Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.7269 13.4469V38.5531H38.8331V13.4469H13.7269Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M51.2799 19.7752C51.2799 21.4934 49.8857 22.8876 48.1676 22.8876C46.4494 22.8876 45.0552 21.4934 45.0552 19.7752C45.0552 18.057 46.4494 16.6628 48.1676 16.6628C49.8857 16.6628 51.2799 18.057 51.2799 19.7752Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M45.0552 19.7753H38.8331"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M51.2799 32.2247C51.2799 33.9429 49.8857 35.3371 48.1676 35.3371C46.4494 35.3371 45.0552 33.9429 45.0552 32.2247C45.0552 30.5065 46.4494 29.1123 48.1676 29.1123C49.8857 29.1123 51.2799 30.5065 51.2799 32.2247Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M45.0552 32.2246H38.8331"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.28003 19.7752C1.28003 21.4934 2.67423 22.8876 4.39241 22.8876C6.1106 22.8876 7.5048 21.4934 7.5048 19.7752C7.5048 18.057 6.1106 16.6628 4.39241 16.6628C2.67423 16.6628 1.28003 18.057 1.28003 19.7752Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.7269 19.7753H7.50476"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.28003 32.2247C1.28003 33.9429 2.67423 35.3371 4.39241 35.3371C6.1106 35.3371 7.5048 33.9429 7.5048 32.2247C7.5048 30.5065 6.1106 29.1123 4.39241 29.1123C2.67423 29.1123 1.28003 30.5065 1.28003 32.2247Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.7269 32.2246H7.50476"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.1676 38.5531V47.8876H15.3707"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.3706 47.8875C15.3706 49.6057 13.9791 50.9999 12.2583 50.9999C10.5374 50.9999 9.14587 49.6057 9.14587 47.8875C9.14587 46.1693 10.5401 44.7751 12.2583 44.7751C13.9764 44.7751 15.3706 46.1693 15.3706 47.8875Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.3923 38.5531V47.8876H37.1892"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.1892 47.8875C37.1892 49.6057 38.5808 50.9999 40.3016 50.9999C42.0224 50.9999 43.414 49.6057 43.414 47.8875C43.414 46.1693 42.0198 44.7751 40.3016 44.7751C38.5834 44.7751 37.1892 46.1693 37.1892 47.8875Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.3707 4.1123H23.1676V13.4468"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.3706 4.11238C15.3706 2.3942 13.9791 1 12.2583 1C10.5374 1 9.14587 2.3942 9.14587 4.11238C9.14587 5.83057 10.5401 7.22477 12.2583 7.22477C13.9764 7.22477 15.3706 5.83057 15.3706 4.11238Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.3923 13.4468V4.1123H37.1892"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.1892 4.11238C37.1892 2.3942 38.5808 1 40.3016 1C42.0224 1 43.414 2.3942 43.414 4.11238C43.414 5.83057 42.0198 7.22477 40.3016 7.22477C38.5834 7.22477 37.1892 5.83057 37.1892 4.11238Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_955_7771">
        <rect
          width="52"
          height="52"
          fill={color}
          transform="translate(0.280029)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default ChipSVG;
